import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import StorageDeleteModal from './StorageDeleteModal'
import { actions, types } from '../../../store'

const mapStateToProps = state => ({
  storage: state.storage,
  status: state.modal.storageDeleteModal
})

const mapDispatchToProps = dispatch => bindActionCreators({
  closeModal: () => actions.modal.setModal(types.MODAL_STORAGE_DELETE, false),
  deleteStorageResourceById: actions.storage.deleteStorageResourceById,
  deleteStorageResourceByArray: actions.storage.deleteStorageResourceByArray,
  setTable: actions.storage.setTable
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StorageDeleteModal)



// WEBPACK FOOTER //
// ./src/components/Modals/StorageDeleteModal/index.js